import { useChannelSensor } from '@aicon-dev/caas-chat'
import React, { createContext } from 'react'

export const HeaderMenuContext = createContext({ unreadMessageCount: 0 })

export const HeaderMenuProvider = ({ channelUrl, children }) => {
    const { unreadMessageCount } = useChannelSensor(channelUrl)
    return <HeaderMenuContext.Provider value={{ unreadMessageCount }}>{children}</HeaderMenuContext.Provider>
}



// WEBPACK FOOTER //
// ./Src/Components/Commons/HeaderMenu.Context.js